import makeApiCall from "./master/axiosIndex";

export const uploadApis = {
  fetchWBSWithPagination: (params: any): Promise<any> => {
    return makeApiCall({
      url: "/excel-upload/list",
      method: "get",
      params,
    });
  },

  fetchWBSReportById: (
    reportId: number,
    pageNo = 1,
    size = 10
  ): Promise<any> => {
    return makeApiCall({
      url: `/excel-upload/fetchReportById`,
      method: "get",
      params: {
        reportId: reportId,
        pageNo,
        size,
      },
    });
  },

  // Master data for the task-resource / task-tool bulk upload templates.
  // Sections are trimmed to the uploadType; unused sections are absent, not empty.
  fetchBulkUploadMasterData: (
    projectId: number | string,
    uploadType?: "task-resource-upload" | "task-tool-upload"
  ): Promise<any> =>
    makeApiCall({
      url: "/excel-upload/masterData",
      method: "get",
      params: { projectId, ...(uploadType ? { uploadType } : {}) },
    }),

  processExcelCreationById: (reportId: number): Promise<any> =>
    makeApiCall({
      url: `/excel-upload/processExcelCreationById`,
      method: "patch",
      params: { id: reportId },
    }),

  deleteExcelCreationById: (reportId: number): Promise<any> =>
    makeApiCall({
      url: `/excel-upload/deleteExcelCreationById`,
      method: "delete",
      params: { id: reportId },
    }),
};
